"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FovError extends Error {
    constructor(errorCode, message) {
        super(message);
        this.errorCode = errorCode;
    }
}
exports.FovError = FovError;
class FovInvalidOperatorError extends FovError {
    constructor(field) {
        super('FOV.INVALID_OPERATOR', `Fov with invalid operator for field ${field}`);
    }
}
exports.FovInvalidOperatorError = FovInvalidOperatorError;
class FovIndexOutOfBoundsError extends FovError {
    constructor(index, length) {
        super('FOV.INDEX_OUT_OF_BOUNDS', `Trying to access index ${index} while size is ${length}`);
    }
}
exports.FovIndexOutOfBoundsError = FovIndexOutOfBoundsError;
class FovExcludeAllVisitorsError extends FovError {
    constructor() {
        super('FOV.INVALID_GOAL', `Cannot exclude segments all visitors`);
    }
}
exports.FovExcludeAllVisitorsError = FovExcludeAllVisitorsError;
class FovInvalidGoalError extends FovError {
    constructor(goalId) {
        super('FOV.INVALID_GOAL', `Fov has an invalid goal ${goalId}`);
    }
}
exports.FovInvalidGoalError = FovInvalidGoalError;
class FovInvalidPageError extends FovError {
    constructor(pageId) {
        super('FOV.INVALID_PAGE', `Fov has an invalid page: ${pageId}`);
    }
}
exports.FovInvalidPageError = FovInvalidPageError;
class FovInvalidZoneError extends FovError {
    constructor(zoneId) {
        super('FOV.INVALID_ZONE', `Fov has an invalid zone: ${zoneId}`);
    }
}
exports.FovInvalidZoneError = FovInvalidZoneError;
class FovInvalidSegmentError extends FovError {
    constructor(segmentId) {
        super('FOV.INVALID_SEGMENT', `Fov has an invalid segment: ${segmentId}`);
    }
}
exports.FovInvalidSegmentError = FovInvalidSegmentError;
class FovInvalidUrlError extends FovError {
    constructor(url) {
        super('FOV.INVALID_URL', `Fov has an invalid URL: ${url}`);
    }
}
exports.FovInvalidUrlError = FovInvalidUrlError;
//# sourceMappingURL=fov-errors.js.map